<script lang="ts">
    import { Dot, Label } from "attractions";
    import Purchase from "../../../Models/Purchase";
    import { LATEST_PURCHASE_WITH_CLEARANCE_ACTION } from "../../../Stores/Purchase";
    import Currency from "../../../Utils/Currency";

    export let sum;     

    let confirmClearanceAllPaidPurchasesMode: boolean = false;

    async function clearAllPaidPurchases() {
        const res = await Purchase.clearAllPaidPurchases();
        if (res) {
            LATEST_PURCHASE_WITH_CLEARANCE_ACTION.set('all');
            toggleClearanceAllPaidPurchasesMode();
        }
    }

    function toggleClearanceAllPaidPurchasesMode() {
        confirmClearanceAllPaidPurchasesMode = !confirmClearanceAllPaidPurchasesMode;
    }
</script>

{#if sum > 0}
    <section class="clearAllPaidPurchases">
        <Label small style="margin-bottom: .25rem">Kwota {Currency.format(sum)} jest poprawna?</Label>
        {#if !confirmClearanceAllPaidPurchasesMode}
            <small>Jeżeli tak, możesz też <span on:click={toggleClearanceAllPaidPurchasesMode} class="clearButton"><Dot style="margin-right: .2rem" /> rozliczyć wszystkie zakupy</span></small>
        {:else}
            <small class="confirmation">
                <span><strong>Uwaga:</strong> spowoduje to rozliczenie <strong>wszystkich zakupów</strong>. Ta operacja jest nieodwracalna.</span>
                <section class="actions">
                    <small class="actionButton" on:click={clearAllPaidPurchases}><Dot small style="margin-right: .25rem" /> Tak, jest w porządku</small>
                    <small class="actionButton" on:click={toggleClearanceAllPaidPurchasesMode}><Dot danger small style="margin-right: .25rem" /> Anuluj</small>
                </section>
            </small>
        {/if}
    </section>
{/if}

<style lang="scss">
    .clearAllPaidPurchases {
        color: gray;
        margin-bottom: .5rem;

        small {
            font-size: .75rem;
            display: flex;
            
            .clearButton {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin-left: .3rem;
                color: #2e2d2d;
            }
        }

        .confirmation {
            display: flex;
            flex-direction: column;

            strong {
                font-weight: bold;
                color: #4300b0;
            }

            .actions {
                margin-top: .3rem;
                display: flex;

                .actionButton {
                    margin: {
                        left: .5rem;
                    }
                    display: flex;
                    align-items: center;
                    font-size: .75rem;
                    cursor: pointer;

                    &:first-of-type {
                        margin-left: 0;
                    }
                }
            }
        }
    }
</style>